/**
 * Where a confirmation link lands, and what it said - C-124.
 *
 * Every confirmation link sends the browser to `/sign-in?verified=1`, and
 * Better Auth appends `&error=...` when the token was expired, already spent
 * or not valid (`emailVerificationUrl` in `server/src/auth/auth.ts`).
 *
 * A **signed-out** visitor reads the answer on the sign-in page, as they
 * always have. A **signed-in** one never reached that page: `RequireAnonymous`
 * sent them to the dashboard, so a link that worked and a link that did not
 * looked the same. That is how WAIT-A defect D1 went unseen.
 */
export type ConfirmationOutcome = 'confirmed' | 'failed';

export function confirmationOutcome(search: string): ConfirmationOutcome | null {
  const params = new URLSearchParams(search);
  if (params.get('verified') !== '1') return null;
  return params.get('error') === null ? 'confirmed' : 'failed';
}

/** The history-state key the outcome travels under, from the guard to the dashboard. */
export const CONFIRMATION_STATE_KEY = 'confirmationLink';
